// src/components/HeaderNav.js
//
// After the sidebar migration, HeaderNav only renders the minimal branded
// top bar for the /auth (logged-out) state. Logged-in navigation lives in
// Sidebar.js, which returns null when there's no session — so exactly one
// of the two ever paints per session state.
//
import React, { useState, useEffect } from 'react';
import { Navbar, NavbarBrand } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import { getCurrentUser } from '../utils/auth';

const Header = () => {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setLoggedInUser(getCurrentUser() || null);
  }, [location]);

  // Logged-in: Sidebar owns navigation.
  if (loggedInUser) return null;

  // Logged-out: minimal branded header — no protected menus, which would
  // just bounce every click through RequireAuth.
  return (
    <Navbar color="light" light expand="md" className="fixed-top">
      <NavbarBrand tag={Link} to="/">
        <img
          src="https://leansixsigmainstitute.org/wp-content/uploads/2023/11/cropped-LOGO-LSSI-ID.png"
          width="170"
          className="App-logo"
          alt="LSSI"
        />
      </NavbarBrand>
      <div className="ms-auto" style={{ fontSize: '0.9rem', color: '#6b7280' }}>
        <Link to="/" style={{ color: '#dc3545', fontWeight: 500, textDecoration: 'none' }}>
          Iniciar sesión
        </Link>
      </div>
    </Navbar>
  );
};

export default Header;
